export default __webpack_public_path__ + "static/media/gold.fabec703.svg";